export class ListIngestionPipelinesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ingestionPipelines",
            "baseName": "ingestionPipelines",
            "type": "Array<IngestionPipeline>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelinesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
